import { apiGet, apiPost } from './client'
import type { ApiResponse } from '@crm/shared'
import type { RecordRow } from './records'

export async function fetchDeletedData(params?: { object_id?: string; cursor?: string; limit?: number }) {
  const searchParams = new URLSearchParams()
  if (params?.object_id) searchParams.set('object_id', params.object_id)
  if (params?.cursor) searchParams.set('cursor', params.cursor)
  if (params?.limit) searchParams.set('limit', String(params.limit))
  const qs = searchParams.toString()
  return apiGet<{ data: RecordRow[]; pagination: { next_cursor: string | null; has_more: boolean } }>(
    `/settings/deleted-data${qs ? `?${qs}` : ''}`,
  )
}

export async function restoreRecords(recordIds: string[]) {
  return apiPost<ApiResponse<{ success: boolean }>, { record_ids: string[] }>(
    '/settings/deleted-data/restore',
    { record_ids: recordIds },
  )
}

export async function permanentDeleteRecords(recordIds: string[]) {
  return apiPost<ApiResponse<{ success: boolean }>, { record_ids: string[] }>(
    '/settings/deleted-data/permanent-delete',
    { record_ids: recordIds },
  )
}
